// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Y33p","buttons":"Footer_buttons__2o_fu"};